import { createRouter, createWebHistory } from 'vue-router'
import App from './app'
import Auth from './auth'
import PageNotFound from '@/components/PageNotFound'
import BrowserNotSupported from '@/components/BrowserNotSupported'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    ...App.routes,
    ...Auth.routes,
    {
      path: '/',
      name: 'BrowserNotSupported',
      component: BrowserNotSupported
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'PageNotFound',
      component: PageNotFound
    }
  ]
})

export default router
